<script setup>
    /**
     * Vue Scripts /Component
     *
     * @link https://vue-final-modal.org/api/components/vue-final-modal/
     */
    import {VueFinalModal} from 'vue-final-modal'

    defineProps({
        title: String,
        content: String,
        confirmText: String,
        modalId: String,
        denyText: String,
    })

    const emit = defineEmits(
        [
            'confirm',
            'deny'
        ]
    )
</script>

<template>
    <VueFinalModal

        :modal-id="modalId"
        :id="modalId"

        background="non-interactive"
        class="modal"
        content-class="modal__dialog"
        overlay-transition="vfm-fade"
        content-transition="vfm-fade"
    >
        <div
            class="modal__title"
            v-html="title"
        />
        <div
            class="modal__body"
            v-html="content"
        />
        <div
            v-if="denyText || confirmText"
            class="modal__footer"
        >
            <button v-if="denyText"
                    class="deny-button"
                    type="button"
                    tabindex="-1"
                    @click="emit('deny')"
                    v-html="denyText" />
            <button v-if="confirmText"
                    class="confirm-button"
                    type="button"
                    tabindex="-1"
                    @click="emit('confirm')"
                    v-html="confirmText" />
        </div>
    </VueFinalModal>
</template>

<script>
    import 'vue-final-modal/style.css'

    export default {
        name: "Modal"
    }
</script>

<style lang="scss" scoped>

</style>
